export const DEFAULT_USER_ID = 'none';
